import React, { Component } from 'react'
import { connect } from 'react-redux';

import Header from '../../components/Header'
import BarraLateral from '../../components/BarraLateral';
import Lista from './lista'
import Sobre_doc from './sobre_doc'

import './documentos.css'
import {

} from '../../actions'

class Documentos extends Component {

    constructor(){
        super()
    }

    componentDidMount(){

    }

    render(){
        const { documento } = this.props.documentos
        //console.log('docs', documento)
        return(
            <div className="principal">
                <Header />
                
                <BarraLateral />

                {documento == undefined
                    ? <Lista />
                    :<Sobre_doc />
                }                
                
            </div>
        )
    }
}


const mapStateToProps = ({ documentos, auth }) => {
    return {
        auth,
        documentos,
    }
}

export default connect(mapStateToProps, {

})(Documentos);